// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__3s47e","label":"Labeled_label__1G71P","divider":"Labeled_divider__1xyiB"};